(function() {
  'use strict';

  var SELECTORS = {
    trigger: '.quickview-trigger',
    drawer: '.quickview-drawer',
    backdrop: '.quickview-drawer__backdrop',
    close: '.quickview-drawer__close',
    content: '.quickview-drawer__content',
    mediaScroll: '.quickview-drawer__media-scroll',
    addToCart: '.quickview-drawer__add-to-cart',
    error: '.quickview-drawer__error',
    success: '.quickview-drawer__success'
  };

  var state = {
    isOpen: false,
    isLoading: false,
    product: null,
    selectedOptions: {},
    selectedVariant: null,
    drawerEl: null,
    backdropEl: null,
    hiddenVariantIds: [],
    hiddenColorValues: []
  };

  function init() {
    createDrawerElements();
    bindGlobalEvents();
  }

  function createDrawerElements() {
    if (document.querySelector(SELECTORS.drawer)) return;

    var backdrop = document.createElement('div');
    backdrop.className = 'quickview-drawer__backdrop';
    document.body.appendChild(backdrop);
    state.backdropEl = backdrop;

    var drawer = document.createElement('div');
    drawer.className = 'quickview-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.innerHTML = getDrawerTemplate();
    document.body.appendChild(drawer);
    state.drawerEl = drawer;

    backdrop.addEventListener('click', closeDrawer);
    drawer.querySelector(SELECTORS.close).addEventListener('click', closeDrawer);
    drawer.addEventListener('click', handleDrawerClick);
  }

  function getDrawerTemplate() {
    return [
      '<div class="quickview-drawer__header">',
        '<button type="button" class="quickview-drawer__close" aria-label="Close">',
          '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74" fill="none"/></svg>',
        '</button>',
      '</div>',
      '<div class="quickview-drawer__content">',
        '<div class="quickview-drawer__loading">',
          '<div class="quickview-drawer__spinner"></div>',
        '</div>',
      '</div>'
    ].join('');
  }

  function bindGlobalEvents() {
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest(SELECTORS.trigger);
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var handle = trigger.getAttribute('data-product-handle');
        if (handle) {
          openDrawer(handle);
        }
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && state.isOpen) {
        closeDrawer();
      }
    });
  }

  function openDrawer(handle) {
    if (state.isLoading) return;

    state.isOpen = true;
    state.isLoading = true;
    state.drawerEl.classList.add('is-open');
    state.backdropEl.classList.add('is-visible');
    state.drawerEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('quickview-drawer-open');

    showLoading();
    fetchProduct(handle);
  }

  function closeDrawer() {
    state.isOpen = false;
    state.product = null;
    state.selectedOptions = {};
    state.selectedVariant = null;
    state.drawerEl.classList.remove('is-open');
    state.backdropEl.classList.remove('is-visible');
    state.drawerEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('quickview-drawer-open');
  }

  function showLoading() {
    var content = state.drawerEl.querySelector(SELECTORS.content);
    content.innerHTML = [
      '<div class="quickview-drawer__loading">',
        '<div class="quickview-drawer__spinner"></div>',
      '</div>'
    ].join('');
  }

  function fetchProduct(handle) {
    // Use Section Rendering API to get product data with availability
    fetch('/products/' + handle + '?sections=quickview-product-data')
      .then(function(response) {
        if (!response.ok) throw new Error('Product not found');
        return response.json();
      })
      .then(function(sectionsData) {
        // Parse the product JSON from the section HTML
        var sectionHtml = sectionsData['quickview-product-data'];
        var parser = new DOMParser();
        var doc = parser.parseFromString(sectionHtml, 'text/html');
        var jsonScript = doc.querySelector('[data-quickview-product]');

        if (!jsonScript) {
          throw new Error('Product data not found in section');
        }

        var productData = JSON.parse(jsonScript.textContent);
        console.log('[Quickview] Product data from section:', productData);

        state.product = productData;
        state.hiddenColorValues = productData.hidden_colors || [];
        state.isLoading = false;

        console.log('[Quickview] Hidden colors:', state.hiddenColorValues);

        initializeSelectedOptions();
        renderProduct();
      })
      .catch(function(error) {
        console.error('[Quickview] Error fetching product:', error);
        state.isLoading = false;
        showError('Unable to load product. Please try again.');
      });
  }

  function initializeSelectedOptions() {
    var product = state.product;
    if (!product || !product.options) return;

    console.log('[Quickview] Product variants count:', product.variants.length);
    console.log('[Quickview] All variants:', product.variants.map(function(v) {
      return {
        id: v.id,
        title: v.title,
        available: v.available,
        hide_variant: v.hide_variant,
        option1: v.option1,
        option2: v.option2
      };
    }));

    // Find first available variant that is not hidden
    var firstAvailable = product.variants.find(function(v) {
      return v.available && !v.hide_variant;
    });

    // Fallback to first available (even if hidden)
    if (!firstAvailable) {
      firstAvailable = product.variants.find(function(v) {
        return v.available;
      });
    }

    // Final fallback to first variant
    if (!firstAvailable) {
      console.log('[Quickview] No available variants found, using first variant');
      firstAvailable = product.variants[0];
    }

    console.log('[Quickview] First available variant:', firstAvailable ? firstAvailable.title : 'none');

    if (firstAvailable) {
      product.options.forEach(function(option, index) {
        var key = 'option' + (index + 1);
        state.selectedOptions[key] = firstAvailable[key];
      });
    }

    console.log('[Quickview] Selected options:', state.selectedOptions);

    updateSelectedVariant();
  }

  function updateSelectedVariant() {
    var product = state.product;
    if (!product) return;

    state.selectedVariant = product.variants.find(function(variant) {
      return product.options.every(function(option, index) {
        var key = 'option' + (index + 1);
        return variant[key] === state.selectedOptions[key];
      });
    });
  }

  function renderProduct() {
    var product = state.product;
    var content = state.drawerEl.querySelector(SELECTORS.content);

    content.innerHTML = [
      renderMediaGallery(product, getSelectedColorValue()),
      '<div class="quickview-drawer__info">',
        '<h2 class="quickview-drawer__title">' + escapeHtml(product.title) + '</h2>',
        '<div class="quickview-drawer__price">' + renderPrice() + '</div>',
        '<div class="quickview-drawer__error is-hidden"></div>',
        '<div class="quickview-drawer__success is-hidden"></div>',
        renderOptions(product),
        renderAddToCart(),
        '<a href="/products/' + product.handle + '" class="quickview-drawer__view-full">View Full Details</a>',
      '</div>'
    ].join('');

    initMediaScroll();
  }

  function renderMediaGallery(product, selectedColorValue) {
    var selectedColorValue = arguments[1]; // Second parameter
    var images = getFilteredImages(product, selectedColorValue);
    if (images.length === 0) {
      return '<div class="quickview-drawer__media"><div class="quickview-drawer__media-item"><div style="background:#f5f5f5;width:100%;height:100%;"></div></div></div>';
    }

    var mediaHtml = images.map(function(imageObj, index) {
      var imageSrc = typeof imageObj === 'string' ? imageObj : (imageObj.src || '');
      if (!imageSrc) return '';

      var srcset = [
        imageSrc.replace(/\.([^.]+)$/, '_400x600.$1') + ' 400w',
        imageSrc.replace(/\.([^.]+)$/, '_600x900.$1') + ' 600w',
        imageSrc.replace(/\.([^.]+)$/, '_800x1200.$1') + ' 800w'
      ].join(', ');

      return [
        '<div class="quickview-drawer__media-item">',
          '<img src="' + imageSrc.replace(/\.([^.]+)$/, '_600x900.$1') + '"',
            ' srcset="' + srcset + '"',
            ' sizes="(max-width: 420px) 100vw, 420px"',
            ' alt="' + escapeHtml(product.title) + ' - Image ' + (index + 1) + '"',
            ' loading="' + (index === 0 ? 'eager' : 'lazy') + '"',
            ' draggable="false">',
        '</div>'
      ].join('');
    }).join('');

    var indicators = '';
    if (images.length > 1) {
      indicators = '<div class="quickview-drawer__media-indicators">' +
        images.map(function(_, index) {
          return '<span class="quickview-drawer__media-indicator' + (index === 0 ? ' is-active' : '') + '" data-index="' + index + '"></span>';
        }).join('') +
        '</div>';
    }

    return [
      '<div class="quickview-drawer__media">',
        '<div class="quickview-drawer__media-scroll">',
          mediaHtml,
        '</div>',
        indicators,
      '</div>'
    ].join('');
  }

  function getFilteredImages(product, selectedColorValue) {
    if (!product || !product.images || product.images.length === 0) {
      return [];
    }

    // If no color selected, return all images
    if (!selectedColorValue) {
      return product.images;
    }

    // Filter images matching the selected color
    var normalizedColor = selectedColorValue.toLowerCase().replace(/\s+/g, '-');
    var filtered = product.images.filter(function(image) {
      if (!image.alt) return false;
      var colorWay = image.alt.toLowerCase().replace('#color_', '');
      return colorWay === normalizedColor;
    });

    // Fallback: if no color-specific images found, return all images
    return filtered.length > 0 ? filtered : product.images;
  }

  function getColorOptionIndex(product) {
    if (!product || !product.options) return -1;

    for (var i = 0; i < product.options.length; i++) {
      var optionName = getOptionName(product.options[i]);
      if (isColorOption(optionName)) {
        return i;
      }
    }
    return -1;
  }

  function getSelectedColorValue() {
    var colorIndex = getColorOptionIndex(state.product);
    if (colorIndex === -1) return null;

    var optionKey = 'option' + (colorIndex + 1);
    return state.selectedOptions[optionKey] || null;
  }

  function initMediaScroll() {
    var scrollContainer = state.drawerEl.querySelector(SELECTORS.mediaScroll);
    if (!scrollContainer) return;

    var isDown = false;
    var startX;
    var scrollLeft;
    var velocity = 0;
    var lastX;
    var lastTime;
    var animationFrame;

    scrollContainer.addEventListener('mousedown', function(e) {
      isDown = true;
      scrollContainer.classList.add('is-dragging');
      startX = e.pageX - scrollContainer.offsetLeft;
      scrollLeft = scrollContainer.scrollLeft;
      lastX = e.pageX;
      lastTime = Date.now();
      velocity = 0;
      cancelAnimationFrame(animationFrame);
    });

    scrollContainer.addEventListener('mouseleave', function() {
      if (isDown) {
        isDown = false;
        scrollContainer.classList.remove('is-dragging');
        applyMomentum();
      }
    });

    scrollContainer.addEventListener('mouseup', function() {
      if (isDown) {
        isDown = false;
        scrollContainer.classList.remove('is-dragging');
        applyMomentum();
      }
    });

    scrollContainer.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - scrollContainer.offsetLeft;
      var walk = (x - startX) * 1.5;
      scrollContainer.scrollLeft = scrollLeft - walk;

      var now = Date.now();
      var dt = now - lastTime;
      if (dt > 0) {
        velocity = (e.pageX - lastX) / dt;
      }
      lastX = e.pageX;
      lastTime = now;
    });

    function applyMomentum() {
      var friction = 0.95;
      var minVelocity = 0.1;

      function step() {
        if (Math.abs(velocity) < minVelocity) {
          snapToNearest();
          return;
        }
        scrollContainer.scrollLeft -= velocity * 16;
        velocity *= friction;
        animationFrame = requestAnimationFrame(step);
      }
      step();
    }

    function snapToNearest() {
      var itemWidth = scrollContainer.querySelector('.quickview-drawer__media-item').offsetWidth;
      var targetIndex = Math.round(scrollContainer.scrollLeft / itemWidth);
      var targetScroll = targetIndex * itemWidth;
      var startScroll = scrollContainer.scrollLeft;
      var distance = targetScroll - startScroll;
      var duration = 400; // ms - adjust for slower/faster snap
      var startTime = null;

      // Easing function for smooth deceleration
      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function animateSnap(currentTime) {
        if (!startTime) startTime = currentTime;
        var elapsed = currentTime - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var easedProgress = easeOutCubic(progress);

        scrollContainer.scrollLeft = startScroll + (distance * easedProgress);

        if (progress < 1) {
          requestAnimationFrame(animateSnap);
        } else {
          updateIndicators(targetIndex);
        }
      }

      requestAnimationFrame(animateSnap);
    }

    scrollContainer.addEventListener('scroll', debounce(function() {
      var itemWidth = scrollContainer.querySelector('.quickview-drawer__media-item').offsetWidth;
      var index = Math.round(scrollContainer.scrollLeft / itemWidth);
      updateIndicators(index);
    }, 100));

    scrollContainer.addEventListener('touchend', function() {
      setTimeout(function() {
        var itemWidth = scrollContainer.querySelector('.quickview-drawer__media-item').offsetWidth;
        var index = Math.round(scrollContainer.scrollLeft / itemWidth);
        updateIndicators(index);
      }, 300);
    });

    // Click handlers for indicator dots
    var indicatorsContainer = state.drawerEl.querySelector('.quickview-drawer__media-indicators');
    if (indicatorsContainer) {
      indicatorsContainer.addEventListener('click', function(e) {
        var indicator = e.target.closest('.quickview-drawer__media-indicator');
        if (!indicator) return;

        var targetIndex = parseInt(indicator.getAttribute('data-index'), 10);
        var itemWidth = scrollContainer.querySelector('.quickview-drawer__media-item').offsetWidth;
        scrollToIndex(targetIndex, itemWidth);
      });
    }

    function scrollToIndex(targetIndex, itemWidth) {
      var targetScroll = targetIndex * itemWidth;
      var startScroll = scrollContainer.scrollLeft;
      var distance = targetScroll - startScroll;
      var duration = 400;
      var startTime = null;

      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function animateScroll(currentTime) {
        if (!startTime) startTime = currentTime;
        var elapsed = currentTime - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var easedProgress = easeOutCubic(progress);

        scrollContainer.scrollLeft = startScroll + (distance * easedProgress);

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        } else {
          updateIndicators(targetIndex);
        }
      }

      requestAnimationFrame(animateScroll);
    }
  }

  function updateIndicators(activeIndex) {
    var indicators = state.drawerEl.querySelectorAll('.quickview-drawer__media-indicator');
    indicators.forEach(function(indicator, index) {
      indicator.classList.toggle('is-active', index === activeIndex);
    });
  }

  function updateMediaGallery() {
    var product = state.product;
    if (!product) return;

    var mediaContainer = state.drawerEl.querySelector('.quickview-drawer__media');
    if (!mediaContainer) return;

    var selectedColorValue = getSelectedColorValue();
    var images = getFilteredImages(product, selectedColorValue);

    if (images.length === 0) {
      mediaContainer.innerHTML = '<div class="quickview-drawer__media-item"><div style="background:#f5f5f5;width:100%;height:100%;"></div></div>';
      return;
    }

    // Rebuild media HTML
    var mediaHtml = images.map(function(imageObj, index) {
      var imageSrc = typeof imageObj === 'string' ? imageObj : (imageObj.src || '');
      if (!imageSrc) return '';

      var srcset = [
        imageSrc.replace(/\.([^.]+)$/, '_400x600.$1') + ' 400w',
        imageSrc.replace(/\.([^.]+)$/, '_600x900.$1') + ' 600w',
        imageSrc.replace(/\.([^.]+)$/, '_800x1200.$1') + ' 800w'
      ].join(', ');

      return [
        '<div class="quickview-drawer__media-item">',
          '<img src="' + imageSrc.replace(/\.([^.]+)$/, '_600x900.$1') + '"',
            ' srcset="' + srcset + '"',
            ' sizes="(max-width: 420px) 100vw, 420px"',
            ' alt="' + escapeHtml(product.title) + ' - Image ' + (index + 1) + '"',
            ' loading="' + (index === 0 ? 'eager' : 'lazy') + '"',
            ' draggable="false">',
        '</div>'
      ].join('');
    }).join('');

    // Rebuild indicators
    var indicators = '';
    if (images.length > 1) {
      indicators = '<div class="quickview-drawer__media-indicators">' +
        images.map(function(_, index) {
          return '<span class="quickview-drawer__media-indicator' + (index === 0 ? ' is-active' : '') + '" data-index="' + index + '"></span>';
        }).join('') +
        '</div>';
    }

    // Update DOM
    mediaContainer.innerHTML = [
      '<div class="quickview-drawer__media-scroll">',
        mediaHtml,
      '</div>',
      indicators
    ].join('');

    // Reinitialize scroll handlers
    initMediaScroll();
  }

  function renderPrice() {
    var variant = state.selectedVariant;
    if (!variant) return '';

    var price = formatMoney(variant.price);
    var comparePrice = variant.compare_at_price;

    if (comparePrice && comparePrice > variant.price) {
      return '<span class="quickview-drawer__price-original">' + formatMoney(comparePrice) + '</span>' +
             '<span class="quickview-drawer__price-sale">' + price + '</span>';
    }

    return price;
  }

  function renderOptions(product) {
    if (!product.options || product.options.length === 0) {
      return '';
    }

    var firstOptionName = getOptionName(product.options[0]);
    if (product.options.length === 1 && firstOptionName === 'Title') {
      return '';
    }

    var html = '<div class="quickview-drawer__options">';

    product.options.forEach(function(option, optionIndex) {
      var optionName = getOptionName(option);
      var optionKey = 'option' + (optionIndex + 1);
      var values = getUniqueOptionValues(product, optionIndex);
      var isColor = isColorOption(optionName);
      var selectedValue = state.selectedOptions[optionKey];

      html += '<div class="quickview-drawer__option-group" data-option-index="' + optionIndex + '">';
      html += '<label class="quickview-drawer__option-label">' + escapeHtml(optionName);
      html += '<span class="quickview-drawer__option-label-value" data-option-value>' + escapeHtml(selectedValue || '') + '</span>';
      html += '</label>';
      html += '<div class="quickview-drawer__option-values">';

      values.forEach(function(value) {
        var isSelected = selectedValue === value;
        var isAvailable = isOptionValueAvailable(product, optionIndex, value);

        if (isColor) {
          html += renderColorSwatch(value, isSelected, isAvailable, optionKey);
        } else {
          html += renderSizeButton(value, isSelected, isAvailable, optionKey);
        }
      });

      html += '</div></div>';
    });

    html += '</div>';
    return html;
  }

  function getOptionName(option) {
    return typeof option === 'string' ? option : (option.name || '');
  }

  function getUniqueOptionValues(product, optionIndex) {
    var values = [];
    var option = product.options[optionIndex];
    var optionName = getOptionName(option);
    var isColor = isColorOption(optionName);

    // Use the option values directly from product.options if available
    if (option && option.values && Array.isArray(option.values)) {
      values = option.values.slice(); // Clone the array
    } else {
      // Fallback: build from variants
      var optionKey = 'option' + (optionIndex + 1);
      product.variants.forEach(function(variant) {
        var value = variant[optionKey];
        if (value && values.indexOf(value) === -1) {
          values.push(value);
        }
      });
    }

    // Filter out hidden colors (for color option only)
    if (isColor && state.hiddenColorValues.length > 0) {
      values = values.filter(function(value) {
        var handleValue = handleize(value);
        var isHidden = state.hiddenColorValues.some(function(hidden) {
          return handleize(hidden) === handleValue || hidden === value;
        });
        return !isHidden;
      });
    }

    return values;
  }

  function isColorOption(optionName) {
    var colorTriggers = ['color', 'colour', 'couleur'];
    var lowerName = optionName.toLowerCase();
    return colorTriggers.some(function(trigger) {
      return lowerName.indexOf(trigger) !== -1;
    });
  }

  function isOptionValueAvailable(product, optionIndex, value) {
    var optionKey = 'option' + (optionIndex + 1);

    var result = product.variants.some(function(variant) {
      // Check if this variant has the value we're looking for
      if (variant[optionKey] !== value) return false;

      // Check if variant is available (now we have this from section rendering)
      if (!variant.available) return false;

      // For the first option (usually color), any available variant counts
      if (optionIndex === 0) {
        return true;
      }

      // For subsequent options, check against previously selected options
      for (var idx = 0; idx < optionIndex; idx++) {
        var key = 'option' + (idx + 1);
        var selectedVal = state.selectedOptions[key];
        if (selectedVal && variant[key] !== selectedVal) {
          return false;
        }
      }

      return true;
    });

    return result;
  }

  function renderColorSwatch(value, isSelected, isAvailable, optionKey) {
    var handleValue = handleize(value);
    var colorSwatchFallback = handleize(value.split(' ').pop());
    var colorFileName = handleValue + '_50x50';
    var colorImageUrl = (window.quickviewDrawerConfig && window.quickviewDrawerConfig.fileUrl)
      ? window.quickviewDrawerConfig.fileUrl.replace('FILENAME_PLACEHOLDER', colorFileName)
      : '';
    var selectedClass = isSelected ? ' is-selected' : '';
    var disabledClass = isAvailable ? '' : ' is-disabled';
    var backgroundStyle = 'background-color: ' + colorSwatchFallback + ';';
    if (colorImageUrl) {
      backgroundStyle += ' background-image: url(' + colorImageUrl + ');';
    }

    return [
      '<label class="quickview-drawer__color-swatch color-swatch color-swatch--' + handleValue + selectedClass + disabledClass + '"',
        ' style="' + backgroundStyle + '"',
        ' title="' + escapeHtml(value) + '">',
        '<input type="radio" name="' + optionKey + '" value="' + escapeHtml(value) + '"',
          isSelected ? ' checked' : '',
          isAvailable ? '' : ' disabled',
          ' data-option-key="' + optionKey + '">',
      '</label>'
    ].join('');
  }

  function renderSizeButton(value, isSelected, isAvailable, optionKey) {
    var selectedClass = isSelected ? ' is-selected' : '';
    var disabledClass = isAvailable ? '' : ' is-disabled';

    return [
      '<button type="button" class="quickview-drawer__size-btn' + selectedClass + disabledClass + '"',
        ' data-value="' + escapeHtml(value) + '"',
        ' data-option-key="' + optionKey + '"',
        isAvailable ? '' : ' disabled',
        '>',
        escapeHtml(value),
      '</button>'
    ].join('');
  }

  function renderAddToCart() {
    var variant = state.selectedVariant;

    if (!variant || !variant.available) {
      return '<div class="quickview-drawer__sold-out">Sold Out</div>';
    }

    return [
      '<form class="quickview-drawer__form">',
        '<input type="hidden" name="id" value="' + variant.id + '">',
        '<input type="hidden" name="quantity" value="1">',
        '<button type="submit" class="quickview-drawer__add-to-cart">Add to Cart</button>',
      '</form>'
    ].join('');
  }

  function handleDrawerClick(e) {
    var colorSwatch = e.target.closest('.quickview-drawer__color-swatch');
    if (colorSwatch && !colorSwatch.classList.contains('is-disabled')) {
      var input = colorSwatch.querySelector('input');
      if (input) {
        handleOptionChange(input.getAttribute('data-option-key'), input.value);
      }
      return;
    }

    var sizeBtn = e.target.closest('.quickview-drawer__size-btn');
    if (sizeBtn && !sizeBtn.classList.contains('is-disabled')) {
      handleOptionChange(sizeBtn.getAttribute('data-option-key'), sizeBtn.getAttribute('data-value'));
      return;
    }

    var addToCartBtn = e.target.closest(SELECTORS.addToCart);
    if (addToCartBtn) {
      e.preventDefault();
      handleAddToCart();
      return;
    }

    var form = e.target.closest('.quickview-drawer__form');
    if (form && e.target.type === 'submit') {
      e.preventDefault();
      handleAddToCart();
      return;
    }
  }

  function handleOptionChange(optionKey, value) {
    state.selectedOptions[optionKey] = value;
    updateSelectedVariant();

    // Check if color option changed - update media gallery if so
    var colorIndex = getColorOptionIndex(state.product);
    if (colorIndex !== -1) {
      var colorOptionKey = 'option' + (colorIndex + 1);
      if (optionKey === colorOptionKey) {
        updateMediaGallery();
      }
    }

    updateUI();
  }

  function updateUI() {
    var product = state.product;
    if (!product) return;

    var priceEl = state.drawerEl.querySelector('.quickview-drawer__price');
    if (priceEl) {
      priceEl.innerHTML = renderPrice();
    }

    product.options.forEach(function(option, optionIndex) {
      var optionName = getOptionName(option);
      var optionKey = 'option' + (optionIndex + 1);
      var selectedValue = state.selectedOptions[optionKey];
      var group = state.drawerEl.querySelector('[data-option-index="' + optionIndex + '"]');
      if (!group) return;

      var labelValue = group.querySelector('[data-option-value]');
      if (labelValue) {
        labelValue.textContent = selectedValue || '';
      }

      var isColor = isColorOption(optionName);

      if (isColor) {
        group.querySelectorAll('.quickview-drawer__color-swatch').forEach(function(swatch) {
          var input = swatch.querySelector('input');
          var value = input.value;
          var isSelected = value === selectedValue;
          var isAvailable = isOptionValueAvailable(product, optionIndex, value);

          swatch.classList.toggle('is-selected', isSelected);
          swatch.classList.toggle('is-disabled', !isAvailable);
          input.checked = isSelected;
          input.disabled = !isAvailable;
        });
      } else {
        group.querySelectorAll('.quickview-drawer__size-btn').forEach(function(btn) {
          var value = btn.getAttribute('data-value');
          var isSelected = value === selectedValue;
          var isAvailable = isOptionValueAvailable(product, optionIndex, value);

          btn.classList.toggle('is-selected', isSelected);
          btn.classList.toggle('is-disabled', !isAvailable);
          btn.disabled = !isAvailable;
        });
      }
    });

    var formContainer = state.drawerEl.querySelector('.quickview-drawer__form');
    var soldOutContainer = state.drawerEl.querySelector('.quickview-drawer__sold-out');
    var variant = state.selectedVariant;

    if (variant && variant.available) {
      if (soldOutContainer) {
        soldOutContainer.outerHTML = renderAddToCart();
      } else if (formContainer) {
        var idInput = formContainer.querySelector('input[name="id"]');
        if (idInput) idInput.value = variant.id;
      }
    } else {
      if (formContainer) {
        formContainer.outerHTML = '<div class="quickview-drawer__sold-out">Sold Out</div>';
      }
    }

    hideError();
    hideSuccess();
  }

  function handleAddToCart() {
    var variant = state.selectedVariant;
    if (!variant || !variant.available) return;

    var addToCartBtn = state.drawerEl.querySelector(SELECTORS.addToCart);
    if (!addToCartBtn || addToCartBtn.classList.contains('is-loading')) return;

    addToCartBtn.classList.add('is-loading');
    hideError();
    hideSuccess();

    var formData = new FormData();
    formData.append('id', variant.id);
    formData.append('quantity', 1);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      addToCartBtn.classList.remove('is-loading');

      if (data.status === 422 || data.description) {
        showError(data.description || 'Could not add to cart');
        return;
      }

      showSuccess('Added to cart!');

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data,
          addToCartBtn: addToCartBtn
        },
        bubbles: true
      }));

      // Reload recommendations after cart drawer updates
      // Wait for cart drawer to finish updating, then reload recommendations
      setTimeout(function() {
        // Update the product ID on the container to the newly added product
        var container = document.getElementById('cart-drawer-recommendations-container');
        if (container && data.product_id) {
          container.setAttribute('data-product-id', data.product_id);
        }
        if (window.theme && theme.loadCartRecommendations) {
          theme.loadCartRecommendations();
        }
      }, 600);

      setTimeout(closeDrawer, 1000);
    })
    .catch(function(error) {
      console.error('[Quickview] Add to cart error:', error);
      addToCartBtn.classList.remove('is-loading');
      showError('Could not add to cart. Please try again.');
    });
  }

  function showError(message) {
    var errorEl = state.drawerEl.querySelector(SELECTORS.error);
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.classList.remove('is-hidden');
    }
  }

  function hideError() {
    var errorEl = state.drawerEl.querySelector(SELECTORS.error);
    if (errorEl) {
      errorEl.classList.add('is-hidden');
    }
  }

  function showSuccess(message) {
    var successEl = state.drawerEl.querySelector(SELECTORS.success);
    if (successEl) {
      successEl.textContent = message;
      successEl.classList.remove('is-hidden');
    }
  }

  function hideSuccess() {
    var successEl = state.drawerEl.querySelector(SELECTORS.success);
    if (successEl) {
      successEl.classList.add('is-hidden');
    }
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (cents / 100).toFixed(2);
    if (window.theme && window.theme.settings && window.theme.settings.moneyFormat) {
      return window.theme.settings.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
    }
    return '$' + value;
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function handleize(str) {
    return str.toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-$/, '')
      .replace(/^-/, '');
  }

  function debounce(func, wait) {
    var timeout;
    return function() {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
